<template>
	<button
		class="border-2 border-gray-500 text-ihh-midnight-gray overflow-hidden relative'"
		:class="[
			image ? 'rounded-full' : 'rounded-lg',
			{
				'px-1 py-[2px] text-2xs md:px-2 md:py-1 md:text-xs': small && !image,
				'px-3 py-2 text-sm': !small && !image,
				'ring ring-ihh-midnight-gray bg-ihh-slate-gray/20 border-0 text-ihh-midnight-gray font-semibold': selected,
				'border-ihh-gray/50 bg-ihh-slate-gray/20 text-ihh-midnight-gray/80 opacity-100': available,
				'border-ihh-gray bg-ihh-white text-ihh-midnight-gray/80 opacity-20': !available,
			},
		]"
		style="position: relative"
		:disabled="!available"
	>
		<div v-if="!available" class="absolute top-1/2 left-0 scale-105 -rotate-45 flex border-t-2 border-gray-800 z-50 flex w-full items-center justify-center" />
		<div v-if="image" class="bg-center bg-cover w-12 h-12 rounded-full" :style="`background-image: url(${image})`" />
		<div v-else>{{ option?.label }}</div>
	</button>
</template>

<script>
export default {
	props: ['option', 'variants', 'selectedOptions', 'inventoryTracking', 'small'],
	computed: {
		selected() {
			return this.selectedOptions?.find((o) => o.id == this.option.id)
		},
		available() {
			let otherSelections = this.selectedOptions?.filter((o) => o.optionId != this.option.optionId)
			let variantsWithOtherSelections = this.variants?.filter((v) => otherSelections?.every((o) => v.optionValues?.find((ov) => ov.id == o.id)))
			let variantsWithOtherSelectionsAndThisSelection = variantsWithOtherSelections?.filter((v) => v.optionValues?.find((o) => o.id == this.option.id))
			let availableVariants = variantsWithOtherSelectionsAndThisSelection?.filter((v) => !v.purchasingDisabled && (!this.inventoryTracking || v.inventoryLevel))
			return !!availableVariants?.length
		},
		image() {
			return this.option?.valueData?.imageUrl
		},
	},
}
</script>

<style></style>
